import { imgIllustrationReport } from '@onsaui/icons'

import CreateTaskCard from '@/modules/general/components/CreateTaskCard/CreateTaskCard'
import { TranscriptReport } from '@/modules/task/model'

import CreateTranscriptReportTaskForm from '../CreateTranscriptReportTaskForm/CreateTranscriptReportTaskForm'

const CreateTranscriptReportTaskCard: React.FC<{
  onTaskCreated?: (task: TranscriptReport.Task) => void
  className?: string
  isAnon?: boolean
  creditsCost?: number
}> = ({ onTaskCreated, className, isAnon, creditsCost }) => {
  return (
    <CreateTaskCard
      className={className}
      price={creditsCost}
      illustrationSrc={imgIllustrationReport}
      title="Review Your Call"
      description="Analyze your call performance with summaries, coaching tips, and follow-up recommendations."
      buttonLabel="Get Report"
      modalContent={
        <CreateTranscriptReportTaskForm onTaskCreated={onTaskCreated} isAnon={isAnon} />
      }
    />
  )
}

export default CreateTranscriptReportTaskCard
